/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState, useCallback } from "react";
import { Grid, Typography, TextField, Popover, IconButton, DialogContent, DialogContentText, Dialog, DialogTitle, Button, DialogActions } from "@material-ui/core";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useNavigate } from "react-router-dom";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import ThemeTable from "../../../components/Table/ThemeTable";
import { getAllEmployee, getEmployeesListBasedOnId } from "../../../services/apiservices/employee";
import styles from "../dashboard.module.scss";
import { getDocCount } from "../../../services/apiservices/counters";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { COLLECTIONS, DOMAINURL_SUPPIESEMAIL } from "../../../services/config";
import moment from 'moment';
import { FormatedDates, formDateCustom } from "../../../services/helpers";
import ConfirmationDialog from "../../../components/DialogComponent/ConfirmationDialog";
import { getCategories, getSupplyOrderList, supplyRejectReasons, updateSuppliesStatus, updateSupplyItemsStatus } from "../../../services/apiservices/supplies";
import { saveNotification2 } from "../../../services/apiservices/notifications";
import CommonContext from "../../../hooks/commonContext";
import { Link } from 'react-router-dom';
import { ConfirmationsDialog, SuccessDialog, SuppplyDataDialog } from "../../../components/DialogComponent/SupplyDataDialog";
import { useMediaQuery } from "@mui/material";
import SupplyCommonCard from "../../../components/ResponsiveCardComponent/SupplyComponent/SupplyListPageResponsive";
import AuthContext from "../../../hooks/authContext";
import { getSettings } from "../../../services/apiservices/settings";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CommunicationsCard from "./CommunicationsCard";

const Columns = [
  {
    id: "employeeName",
    numeric: false,
    disablePadding: false,
    label: "Name",
    isSortable: true,
  },
  {
    id: "item",
    numeric: false,
    disablePadding: false,
    label: "Item",
    isSortable: true,
  },
  {
    id: "priority",
    numeric: false,
    disablePadding: true,
    label: "Status",
    isSortable: true,
  },
  {
    id: "date",
    numeric: false,
    disablePadding: true,
    label: "Date",
    isSortable: true,
  },

  {
    id: "viewlink",
    numeric: false,
    isEditRow: true,
    disablePadding: true,
    label: "Action",
    rowclassName: "",
    className: "pr-30",
  },
];

const ColumnsRes = [
  {
    id: "priority",
    numeric: false,
    disablePadding: true,
    label: "Status",
    isSortable: true,
  },
  {
    id: "item",
    numeric: false,
    disablePadding: false,
    label: "Item",
    isSortable: true,
  },
  {
    id: "date",
    numeric: false,
    disablePadding: true,
    label: "Date",
    isSortable: true,
    isCollapsible: true,
  },
];

// const CustomTooltip = ({ listData, data, title }) => {
//   const [anchorEl, setAnchorEl] = useState(null);

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const open = Boolean(anchorEl);

//   return (
//     <div>
//       <div className="d-flex flex-direction-row flex-center">
//         <div className="flex-space-around">{data}</div>
//         <Typography
//           aria-owns={open ? "mouse-over-popover" : undefined}
//           aria-haspopup="true"
//           onClick={handleClick}
//           style={{
//             cursor: "pointer",
//             color: "blue",
//             marginLeft: "8px"
//           }}
//         >{title}
//         </Typography>
//       </div>
//       <Popover
//         id="mouse-over-popover"
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "center",
//         }}
//         transformOrigin={{
//           vertical: "top",
//           horizontal: "center",
//         }}
//       >
//         <div className="tooltip-heading2 p-5">
//           <div className="tooltip-container2">
//             {Array.isArray(listData) ? (
//               <div>
//                 {listData.map((item, index) => (
//                   <div key={index}>
//                     <div>{item.title} ({item.qty})</div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div>{listData}</div>
//             )}
//           </div>
//         </div>
//       </Popover>
//     </div>
//   );
// };

const EmployeeSummary = React.memo(() => {
  const auth = useContext(AuthContext);
  const commonContext = useContext(CommonContext);
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedReason, setSelectedReason] = useState('');
  const [reasonMessage, setReasonMessage] = useState('');
  const [recordID, setRecordID] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [data, setData] = useState();
  const [empData, setEmpData] = useState();
  const [categoryMap, setCategoryMap] = useState({});
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const [expanded, setExpanded] = useState(null);
  const [dialogConfirmOpen, setDialogConfirmOpen] = useState(false);
  const [openSupplyDialog, setOpenSupplyDialog] = useState(false);
  const [openData, setOpenData] = useState(null);
  const [dialogOpenSucces, setDialogOpenSucces] = useState(false);
  const [opens, setOpens] = useState(null);
  const [settingsData, setSettingsData] = useState();
  const [counts, setCounts] = useState();
  const history = useNavigate();
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "1":
        return "High";
      case "2":
        return "Medium";
      case "3":
        return "Low";
      default:
        return "Unknown";
    }
  };
  
  const getEmployeeSummaryData = useCallback(async () => {
    try {
      const [allEmployees, orders] = await Promise.all([
        new Promise((resolve, reject) => getAllEmployee(resolve, reject)),
        new Promise((resolve, reject) =>
          getSupplyOrderList({ companyId }, resolve, reject)
        ),
      ]);

      const activeOrders = orders?.filter((order) => order?.archive !== true);
      const pendingOrders = activeOrders?.filter(
        (order) => order?.status === "Pending"
      );

      const empIds = [...new Set(activeOrders.map((order) => order.createdBy))];

      const employeeData = allEmployees?.data
        ?.filter((emp) => empIds?.includes(emp?.userId))
        ?.map((emp) => ({
          value: emp?.userId,
          label: `${emp?.firstName} ${emp?.lastName}`,
        }));
      setEmpData(employeeData);
      const enrichedOrders = activeOrders?.map((order) => {
        const employee = employeeData?.find((emp) => emp?.value === order?.createdBy);
        const employeeName = employee?.label || "Unknown employee";
        const hasMaxAllowed = order?.supplyItems?.some(
          (item) => item?.maxNumberAllowed !== undefined
        );

        return {
          dateOfRequest: order?.dateOfRequest,
          preview: `${getPriorityLabel(order?.priority || "")} - (${
            hasMaxAllowed ? "Clothing" : "Supplies"
          })`,
          time: formDateCustom(order?.dateOfRequest) || "",
          user: employeeName,
          id: order?.id,
          orderNumber: order?.orderNumber
        };
      });

      const sorted = enrichedOrders
        ?.sort((a, b) => new Date(b.dateOfRequest) - new Date(a.dateOfRequest))
        ?.slice(0, 5);

      setEmployeeList(sorted);
      setCounts(pendingOrders?.length);
    } catch (error) {
      console.error("Error fetching employee summary data:", error);
    }
  }, [companyId]);
  useEffect(() => {
    getEmployeeSummaryData();
  }, [getEmployeeSummaryData]);

    return (
      <CommunicationsCard
        icon={<ErrorOutlineIcon className={styles.iconYellow} />}
        updates={employeeList}
        title="Supply Requests"
        count={counts}
        to="/supplies/cleaning/manage"
        viewAll="/supplies/cleaning/manage"
      />
    );
  });

  // const getviewTag = (cellData, id) => {
  //   return (
  //     <a
  //       className='link2'
  //       href={cellData['viewlink']}
  //       onClick={(e) => {
  //         e.preventDefault();
  //         history("/supplies/cleaning/manage/" + id);
  //       }}
  //     >
  //       View
  //     </a>
  //   );
  // }

  // const fetchAndStoreCategories = async (latestData) => {
  //   const newCategoryMap = {};
    
  //   let categoriesData = [];
  //   try {
  //     await getCategories((res) => {
  //       categoriesData = res;
  //     });
  //   } catch (error) {
  //     console.error("Error fetching categories:", error);
  //     categoriesData = [];
  //   }
  
  //   for (const item of latestData) {
  //     const { id: mainId, supplyItems } = item;
  //     if (supplyItems) {
  //       const categoriesForItem = [];
  //       for (const supplyItem of supplyItems) {
  //         const { parentCategoryId } = supplyItem;
  //         if (parentCategoryId && Array.isArray(categoriesData)) {
  //           try {
  //             const category = categoriesData.find((cate) => cate?.id === parentCategoryId && cate?.companyId === companyId);
  //             const title = category?.title;
  //             if (title) {
  //               categoriesForItem.push({
  //                 parentCategoryId,
  //                 title
  //               });
  //             }
  //           } catch (error) {
  //             console.error(`Error fetching category for parentCategoryId ${parentCategoryId}:`, error);
  //           }
  //         }
  //       }
  //       newCategoryMap[mainId] = categoriesForItem;
  //     }
  //   }
  
  //   setCategoryMap(newCategoryMap);
  // };
  
  

  // const sendRejectNotification = async () => {
  //   let name;
  //   let email;
  //   const orderId = data ? data.orderId : null;
  //   const clientName = data ? data.clientName : null;
  //   const supply = true;

  //   const employee = empData.find(emp => emp.value === data.createdBy);
  //   if (employee) {
  //     name = employee.label;
  //     email = employee.email;
  //   }

  //   let updatedTitles = [];
  //   const category = categoryMap[data.id];
  //   if (category) {
  //     updatedTitles = data.supplyItems.map((supplyItem, index) => {
  //       const categoryItem = category.find(cat => cat.parentCategoryId === supplyItem.parentCategoryId);
  //       const title = categoryItem ? `${categoryItem.title} - ${supplyItem.title}` : `${supplyItem.title}`;
  //       return `${index + 1}. ${title} (${supplyItem.qty})`;
  //     });
  //   }

  //   const updatedTitlesStr = updatedTitles.join('\n');
  //   const link = `https://${DOMAINURL_SUPPIESEMAIL}/Supplies/${data.id}`
  //   const notifications = [
  //     {
  //       Type: "PushNotification",
  //       Message: `Your supply request OrderID ${data.orderId} has been cancelled. Please check your email.`,
  //       read: false,
  //       companyId: companyId,
  //       Employee: [
  //         {
  //           id: data?.createdBy,
  //           name: data?.employeeName
  //         }
  //       ]
  //     },
  //     {
  //       Type: "Email",
  //       Message: `Your supply request OrderId ${data.orderId} has been canceled by the support team.<br>
  //         Please contact us to resubmit a new request or discuss this order with your support team.<br>
  //         Details:\n 
  //         ${updatedTitlesStr}<br><br>
  //         To respond to this message, please click <a href="${link}" target="_blank">here</a> to open the issue in the proteams.io app.<br>
  //         ProTeams Support Team.`,
  //       read: false,
  //       companyId: companyId,
  //       Employee: [
  //         {
  //           id: data?.createdBy,
  //           name: name,
  //           email: email
  //         }
  //       ]
  //     }
  //   ];

  //   await saveNotification2(notifications, supply, orderId, clientName);
  // };

  // const handleCloseSuccesDialog = async () => {
  //   setDialogOpenSucces(false);
  //   setOpens(null);
  //   await getEmployeeSummaryData();
  // };

  // const handleDialogOpen = (item) => {
  //   setSelectedItem(item);
  //   setDialogOpen(true);
  // };

  // const handleDialogClose = () => {
  //   setDialogOpen(false);
  //   setSelectedItem(null);
  //   setSelectedReason('');
  //   setReasonMessage('');
  // };

  // const handleProceed = async () => {

  //   if (!selectedReason && !reasonMessage) {
  //     setAlertOpen(true);
  //     return;
  //   }

  //   const result = {
  //     reason: selectedReason,
  //     message: reasonMessage,
  //   };

  //   commonContext?.setLoader(true);

  //   try {
  //     const formData = {
  //       status: "Rejected"
  //     };

  //     const promises = [
  //       supplyRejectReasons(recordID, result),
  //       updateSuppliesStatus(recordID, formData),
  //       updateSupplyItemsStatus(recordID, "Cancel Item"),
  //       sendRejectNotification()
  //     ];

  //     handleDialogClose();

  //     await Promise.all(promises);

  //     setSelectedReason('');
  //     setReasonMessage('');
  //     await getEmployeeSummaryData();
  //     commonContext?.setLoader(false);
  //   } catch (error) {
  //     console.error("Error handling proceed:", error);
  //   }
  // };

  // const approvedClick = async (id) => {
  //   const formData = {
  //     status: "Approved"
  //   }
  //   await updateSuppliesStatus(id, formData);
  //   setDialogConfirmOpen(false);
  //   setSelectedItem(null);
  //   setDialogOpenSucces(true);
  // }

  // const handelApproveClick = async (id) => {
  //   setDialogConfirmOpen(true);
  //   setSelectedItem(id);
  // }

  // const handleDialogConfirmClose = () => {
  //   setDialogConfirmOpen(false);
  //   setSelectedItem(null);
  // };

  // const getApprovedReject = (cellData) => {
  //   return (
  //     <>
  //       <IconButton
  //         className="mr-10 empSummary"
  //         style={{
  //           color: settingsData ? !settingsData?.approveRequestRole?.includes(auth?.userProfile?.role) ? "gray" : "green" : "green"
  //         }}
  //         onClick={() => handelApproveClick(cellData?.id)}
  //         disabled={settingsData ? !settingsData?.approveRequestRole?.includes(auth?.userProfile?.role) : false}
  //       >
  //         <CheckCircleOutlinedIcon />
  //       </IconButton>
  //       <IconButton
  //         onClick={() => {
  //           handleDialogOpen(cellData?.id);
  //           setRecordID(cellData?.id);
  //           setData(cellData);
  //         }}
  //         style={{
  //           color: settingsData ? !settingsData?.approveRequestRole?.includes(auth?.userProfile?.role) ? "gray" : "red" : "red"
  //         }}
  //         className="empSummary"
  //         disabled={settingsData ? !settingsData?.approveRequestRole?.includes(auth?.userProfile?.role) : false}
  //       >
  //         <CancelOutlinedIcon />
  //       </IconButton>
  //     </>
  //   );
  // }

  // const getStatusTag = (cellData) => {
  //   let status = styles.statusYellow;
  //   let statusColor = styles.statusYellowcolo;
  //   if (cellData['priority'] === '1') {
  //     status = styles.statusRed;
  //     statusColor = styles.statusRedcolo;
  //   }
  //   return <div className={`${statusColor}`}><div className={`${styles.stausCircle} ${status}`}></div>{getPriorityLabel(cellData['priority'])}</div>
  // }

  // const handleDialogSupplyOpen = async (data) => {
  //   setOpenSupplyDialog(true);
  //   setOpenData(data);
  // };

  // const handleDialogSupplyClose = async () => {
  //   setOpenSupplyDialog(false);
  //   setOpenData(null);
  // };

  

  // const renderRow = (cellData, colData, cellIndex, RowIndex) => {
  //   if (cellIndex === 0) {
  //     return <p>{cellData[colData.id]}</p>;
  //   }
  //   else if (cellIndex === 1) {
  //     return (
  //       <>
  //         <CustomTooltip
  //           listData={cellData?.supplyItems}
  //           data={cellData?.item}
  //           title={cellData?.totalQuantity}
  //         />
  //       </>
  //     )
  //   }
  //   else if (cellIndex === 2) {
  //     return getStatusTag(cellData);
  //   }
  //   else if (cellIndex === 3) {
  //     return FormatedDates(cellData?.dateOfRequest);
  //   }
  //   else if (cellIndex === 4) {
  //     if (cellData?.status !== "Pending")
  //       return getviewTag(cellData, cellData.id);
  //     else {
  //       return getApprovedReject(cellData)
  //     }
  //   }
  //   return cellData[colData.id] ? cellData[colData.id] : '';
  // }

  // const handleExpandClick = (id) => {
  //   setExpanded(prevExpanded => (prevExpanded === id ? null : id));
  // };

  // const handelTooltipClicks = (id) => {
  //   setOpens(opens === id ? null : id);
  // }

  // const redirectToDetails = (id) => {
  //   if (typeof id !== "undefined" && id !== "")
  //     history("/supplies/cleaning/manage/" + id);
  // };


      {/* <Grid container alignItems="center" spacing={2} className="mb-10">
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">
            <PersonOutlineOutlinedIcon className="color-primary mr-10 svg-icon" />
            Supply Summary
          </Typography>
        </Grid>
      </Grid>
      <div className={`sectionBox nospacing tabletd shadow ${styles.summaryTableWrap}`}>
        {(!isMobile && !isLandscape) &&
          <ThemeTable
            rows={employeeList}
            headCells={Columns}
            hidePagination={true}
            renderRowCell={renderRow}
          />
        }
        {(isMobile || isLandscape) && (
          <>
            {(employeeList?.length > 0 ? employeeList : []).map((record, index) => {
              const isOpen = expanded === record?.id;
              return (
                <SupplyCommonCard
                  key={record?.id}
                  index={index}
                  record={record}
                  isOpen={isOpen}
                  redirectToDetails={redirectToDetails}
                  handleExpandClick={handleExpandClick}
                  getPriorityLabel={getPriorityLabel}
                  handelTooltipClicks={handelTooltipClicks}
                  opens={opens}
                  handelApproveClick={handelApproveClick}
                  handleDialogOpen={handleDialogOpen}
                  setRecordID={setRecordID}
                  getStatusTag={getStatusTag}
                  setData={setData}
                  handleDialogSupplyOpen={handleDialogSupplyOpen}
                  columns={ColumnsRes}
                  SupplySummary={true}
                  settingsData={settingsData}
                />
              );
            })}
          </>
        )}
        <p className="text-center">
          <Link className="link" to="/supplies/cleaning/manage">View all Supply Summary</Link></p>
      </div>
      {dialogOpen && (
        <ConfirmationDialog
          show={dialogOpen}
          title="Reason to Reject Supply"
          confirmation={
            <>
              <SingleSelect
                select
                label="Reason"
                fullWidth
                margin="normal"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
                options={[
                  { label: "Recent Shipment", value: "Recent Shipment" },
                  { label: "Duplicate Request ", value: "Duplicate Request" },
                  { label: "Contact Management", value: "Contact Management" }
                ]}
              />
              <TextField
                fullWidth
                multiline={true}
                label="Reason Message"
                variant="outlined"
                placeholder="Reason Message"
                rows={3}
                margin="normal"
                value={reasonMessage}
                onChange={(e) => setReasonMessage(e.target.value)}
              />
            </>
          }
          proceed={handleProceed}
          dismiss={handleDialogClose}
          cancel={handleDialogClose}
        />
      )}

      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      >
        <DialogTitle>Missing Information</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please provide a reason or a message before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {dialogConfirmOpen && (
        <ConfirmationsDialog
          open={dialogConfirmOpen}
          onConfirm={() => approvedClick(selectedItem)}
          onClose={handleDialogConfirmClose}
        />
      )}
       <SuccessDialog open={dialogOpenSucces} onClose={handleCloseSuccesDialog} />
      <SuppplyDataDialog open={openSupplyDialog} onClose={handleDialogSupplyClose} listData={openData} /> */}

export default EmployeeSummary;
